import axios from 'axios';
import { getHeaders } from './authHelper';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  // withCredentials: true,
});

api.interceptors.request.use(
  config => {
    // Do something before request is sent
    config.headers = getHeaders();
    return config;
  },
  error => {
    // Do something with request error
    return Promise.reject(error);
  }
);

api.interceptors.response.use(
  response => {
    // Do something with response data
    return response;
  },
  error => {
    // Do something with response error
    if (error.response && (error.response.status === 400 || error.response.status === 401)) {
      //clean cache
      window.location.href = process.env.REACT_APP_LOGIN_URL;
    } else {
      return Promise.reject(error.response);
    }
  }
);

export default api;
